import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import Settings from '@/views/Settings.vue'
import Projects from '@/views/Projects.vue'
import ForgotPassword from '@/views/ForgotPassword'
import NewProject from '@/views/NewProject'
import Home from '@/views/Home'
import Connections from '@/views/Connections'
import Items from '@/views/Items'
import Overview from '@/views/Overview'
import Project from '@/views/Project'
import Pages from '@/views/Pages'
import History from '@/views/History'
import Connector from '@/views/Connector'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/',
      component: Home,
      meta: { auth: true }
    },
    {
      path: '/accounts/:accountId',
      component: Dashboard,
      meta: { auth: true },
      props: true,
      children: [
        {
          path: 'projects',
          name: 'projects',
          component: Projects,
          props: true,
          meta: { auth: true },
        },
        {
          path: 'projects/new',
          name: 'new-project',
          component: NewProject,
          props: true,
          meta: { auth: true },
        },
        {
          path: 'projects/:projectId',
          component: Project,
          props: true,
          meta: { auth: true },
          children: [
            {
              path: '',
              name: 'overview',
              props: true,
              component: Overview
            },
            {
              path: 'entities',
              name: 'entities',
              props: true,
              component: Items
            },
            {
              path: 'pages',
              name: 'pages',
              props: true,
              component: Pages
            },
            {
              path: 'edit',
              name: 'edit',
              props: true,
              component: Settings
            },
            {
              path: 'history',
              name: 'history',
              props: true,
              component: History
            }
          ]
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings,
          meta: { auth: true }
        },
        {
          path: 'connections',
          name: 'connections',
          component: Connections,
          meta: { auth: true }
        },
        {
          path: '/connect/:provider',
          component: Connector,
          meta: { auth: true }
        }
      ]
    }
  ]
})
